import { Component, OnInit, OnDestroy } from '@angular/core';
import { Project } from 'src/app/models/project.model';
import { ActivatedRoute, Router } from '@angular/router';
import { AuthService } from 'src/app/services/auth.service';
import { RequestService } from 'src/app/services/request.service';
import { ModalDialog } from 'src/app/Modal/modal';
import { Subject, Subscription } from 'rxjs';
import { takeUntil, take } from 'rxjs/operators';
import { Wagon } from 'src/app/models/wagon.model';
import { dynamicLocaleCompareWithOptions } from 'src/app/helper/sortFunctions';
import { MatTableDataSource } from '@angular/material/table';
import { MatDialog } from '@angular/material/dialog';

@Component({
  selector: 'app-wagon-list',
  templateUrl: './wagon-list.component.html',
  styleUrls: ['./wagon-list.component.css']
})
export class WagonViewListComponent implements OnInit, OnDestroy {
  //Properties
  private unscubscribe$ = new Subject<void>();
  displayedColumns: string[];
  dataSource = new MatTableDataSource;
  companyId: number;
  projects: Project[];
  selectedProjectId: number;
  private routeSub: Subscription;

  wagon = {
    title: 'Carriage List', dropDownPlaceholder: 'Choose Project', addButton: 'Add New Carriage',
    col1Titel: 'Carriage Name', col2Titel: 'Carriage Description', col3Titel: 'Actions',
    action1: 'Edit Carriage', action2: 'Layout List', action3: 'Evaluate', action4: 'Delete Carriage',
    deleteDialog: 'Do you really want to delete this carriage?'
  }

  // Ctor
  constructor(private router: Router, private requestService: RequestService,
    private authService: AuthService, private dialog: MatDialog, private route: ActivatedRoute) {
  }

  // Lifecycle Hooks
  ngOnInit() {

    this.routeSub = this.route.params.subscribe(params => {
      this.displayedColumns = ['wagonName', 'wagonDescription', 'wagonActions'];
      this.loadProjects();
      this.selectedProjectId = parseInt(params['id'].toString());
      this.loadWagons();
    });

  }

  // Methods
  loadProjects() {
    this.requestService.getProjects(this.authService.getCurrentCompanyId())
      .pipe(take(1)).subscribe(resp => { this.projects = resp; });
  }

  loadWagons() {
    this.requestService.getWagons(this.selectedProjectId)
      .pipe(takeUntil(this.unscubscribe$))
      .subscribe(resp => {
        this.setWagonList(resp);
      },
        err => {
        });
  }

  setWagonList(wagonList: Wagon[]) {
    if (wagonList) {
      this.dataSource.data = wagonList.sort((a, b) => dynamicLocaleCompareWithOptions(a, b, 'name'));
    } else {
      this.dataSource.data = [];
    }
  }

  changeProject(projectId: number) {
    this.router.navigate(['wagon/list', this.selectedProjectId]);
  }

  openCellEdit(wagonId: number) {
    this.router.navigate(['wagon/edit', this.selectedProjectId, wagonId]);
  }

  openVariantList(wagonId: number) {
    this.router.navigate(['layout/list', this.selectedProjectId, wagonId]);
  }

  showDeleteDialog(wagonId: number): void {
    const dialogRef = this.dialog.open(ModalDialog, {
      data: {
        title: 'Warning',
        message: this.wagon.deleteDialog,
        showCancel: true,
        cancelButtonText: 'Cancel',
        saveButtonText: 'Okay'
      }
    });

    dialogRef.afterClosed()
      .pipe(takeUntil(this.unscubscribe$))
      .subscribe(result => {
        if (result) {
          this.deleteWagon(wagonId);
        } else {
          // do nothing just close the modal
        }
      });
  }

  deleteWagon(wagonId: number) {
    this.requestService.deleteWagon(wagonId)
      .pipe(takeUntil(this.unscubscribe$))
      .subscribe((resp: any) => {
        this.setWagonList(resp);
      }, error => {
        //
      });
  }

  createWagon() {
    this.router.navigate(['wagon/edit', this.selectedProjectId, -1]);
  }

  ngOnDestroy(): void {
    this.unscubscribe$.next();
    this.unscubscribe$.complete();
    this.routeSub.unsubscribe();
  }
}